import { Component, Input } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { CardCenterService } from 'src/app/pages/card-center/card-center.service';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

@Component({
  selector: 'app-user-avatar',
  standalone: true,
  imports: [PipesModule],
  templateUrl: './user-avatar.component.html',
  styleUrl: './user-avatar.component.scss',
})
export class UserAvatarComponent {
  constructor(
    private appService: AppService,
    private cardCenterService: CardCenterService,
  ) {}

  /** 是否处于活跃状态 */
  @Input() isActive = false;

  /** 卡券数量 */
  @Input() bounsCount = 0;

  /** 用户头像圖片資源 */
  @Input() avatarImgSrc = '';
  @Input() size: 'default' | 'large' | 'tiny' = 'default';

  /** 当前有多少信息未读 */
  @Input() messagesCount: number = 0;

  /** 当前vip等级 */
  private _currentVipLevel = 0;
  @Input() get currentVipLevel(): number {
    return this._currentVipLevel;
  }
  set currentVipLevel(vipLevel: number) {
    this._currentVipLevel = vipLevel;
    if (this._currentVipLevel === null || this._currentVipLevel === undefined) {
      this.vipImgSrc = '';
      return;
    }

    this.vipImgSrc = `assets/images/vip/vip_${this._currentVipLevel}.png`;
  }

  /** 是否為超級vip等级 */
  @Input() isSuperVip = false;

  /** vip圖片資源 */
  protected vipImgSrc = '';
}
